<template>
  <div :class="{'active':show$}" class="tab-pane">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'TTabPanel',
  props: {
    name: String,
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show$: true,
      name$: this.name
    }
  },
  watch: {
    disabled(val) {
      this.update()
    },
    name(val) {
      this.name$ = val
      this.update()
    },
    label() {
      this.update()
    },
    icon() {
      this.update()
    }
  },
  mounted() {
    this.update()
  },
  methods: {
    update() {
      this.$parent.$emit('tabs-refresh')
    }
  }
}
</script>



// WEBPACK FOOTER //
// panel.vue?0ae595c6